"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importStar(require("styled-components"));
const expandCss = styled_components_1.css `
    margin-bottom: 1.5em;
    .ecr-faqItem-question {
        .expand-icon:after {
            content: '-';
        }
    }
`;
exports.default = styled_components_1.default.div `
    border-top: 1px solid #002a442e;
    .ecr-faqItem-question {
        cursor: pointer;
        display: flex;
        h3 {
            flex: 1;
        }
        .expand-icon {
            min-width: 4em;
            text-align: center;
            font-weight: bolder;
            &:after {
                content: '+';
                font-weight: bolder;
                font-size: 2em;
            }
        }
    }
    .ecr-faqItem-answer {
        overflow: hidden;
        transition: max-height 0.2s linear;
        max-width: calc(100% - 6em);
    }
    ${({ expand }) => (expand ? expandCss : '')}
`;
//# sourceMappingURL=FaqItemStyled.js.map